module.exports = __webpack_public_path__ + "img/essentials-w.svg";